import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const MMPhysicalVerificationMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default MMPhysicalVerificationMonitorPage;
